import React from 'react';
import styled from 'styled-components';

import Button from '../Button';

const Link = styled(props => <Button tertiary {...props} />)`
  font-size: 0.875rem;
  padding: 0.1rem 0.25rem;
  margin-left: 0.2rem;
`;

export default Link;